import React, { useRef } from 'react';
import { makeStyles, useTheme, alpha } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Badge from '@material-ui/core/Badge';
import clsx from 'clsx';
import { nanoid } from 'nanoid';
import { mergeClasses } from '@material-ui/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
        borderRadius: '50%',
        width: ({ size }) => size,
        height: ({ size }) => size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    badge: Object.assign(Object.assign({ backgroundColor: theme.palette.primary.dark, color: theme.palette.primary.contrastText, right: '50%', top: 0, width: '30px', height: '30px', borderRadius: '50%' }, theme.typography.body2), { fontSize: '13px' }),
    progress: {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        position: 'absolute',
    },
    placeholder: {
        color: theme.palette.grey[100],
    },
    circle: {
        stroke: ({ trustId }) => `url(#${trustId})`,
        strokeLinecap: 'round',
    },
    content: {
        width: '80%',
        height: '80%'
    },
    trustSVG: {
        position: 'absolute',
        bottom: 0,
        zIndex: -1,
    },
}), { name: 'TpTrustBadge' });
/**
 * An opinionated badge representing the trust of the user.
 * */
const TrustBadge = ({ children, value = 0, size = 40, thickness = 2.5, invisible = false, withoutPlaceholder = false, classes: newClasses = {} }) => {
    const trustIdRef = useRef(nanoid());
    const baseClasses = useStyles({ trustId: trustIdRef.current, size });
    const theme = useTheme();
    const classes = mergeClasses({
        baseClasses,
        newClasses,
        Component: TrustBadge
    });
    return (React.createElement(Badge, { badgeContent: value, overlap: 'circular', classes: {
            badge: classes.badge,
        }, invisible: invisible, max: 100 },
        React.createElement("div", { className: classes.root },
            React.createElement("div", { className: classes.content }, children),
            !withoutPlaceholder && (React.createElement(CircularProgress, { thickness: thickness, variant: 'determinate', value: 100, size: size, classes: {
                    root: clsx(classes.progress, classes.placeholder),
                } })),
            React.createElement(CircularProgress, { thickness: thickness, variant: 'determinate', value: invisible ? 0 : value, size: size, classes: {
                    root: classes.progress,
                    circle: classes.circle,
                } }),
            React.createElement("svg", { width: '0', height: '0', className: classes.trustSVG },
                React.createElement("linearGradient", { id: trustIdRef.current, x1: '0', y1: '0', x2: '1', y2: '1' },
                    React.createElement("stop", { offset: '0%', stopColor: theme.palette.error.main }),
                    React.createElement("stop", { offset: '100%', stopColor: alpha(theme.palette.primary.main, 0.67) }))))));
};
export default TrustBadge;
